<template>
  <div>
    <MenuMovilTP />
    <MenuMovilUni />
    <main class="container dkt mb-4 px-0 px-md-3 fc fc3">
      <Titulo
        :titulo1="carrera.nombreCorto"
        :titulo2="nombreCarrera"
        :titulo3="tituloEntregado"
        :titulo4="gradoAcademicoTexto"
        :demre="codigoDemre"
        tipoEncabezado="FICHA_CARRERA"
        :volverA="origenRedirect"
        :datosContacto="datosContactame"
        @descargar="descargarFicha"
      />
      <div class="col mb-3 px-0">
        <div class="px-0">
          <IconosDesktop
            v-if="sede"
            :acreditacion="carrera.acreditacion"
            :acreditado="carrera.acreditado"
            :gratuidad="carrera.gratuidad"
            :sede="sede"
            :web="carrera.contacto.paginaWeb"
            :urlLogo="carrera.codigo"
            :telefono="carrera.contacto.telefono"
            :tipoPostulacion="tipoPostulacionTexto"
            :leyExcepcion="carrera.observacionAcreditacionCNA"
            :situacionM2="textoM2"
          />
          <IconosMobile
            v-if="sede"
            :acreditacion="carrera.acreditacion"
            :acreditado="carrera.acreditado"
            :gratuidad="carrera.gratuidad"
            :sede="sede"
            :web="carrera.contacto.paginaWeb"
            :urlLogo="carrera.codigo"
            :telefono="carrera.contacto.telefono"
            :tipoPostulacion="tipoPostulacionTexto"
            :leyExcepcion="carrera.observacionAcreditacionCNA"
            :situacionM2="textoM2"
          />
        </div>
        <DetallesCarreraTP v-if="sede" :carrera="detalleCarrera" />
      </div>
    </main>
  </div>
</template>

<script>
import Titulo from "@/components/generales/paginas/TituloFicha";
import IconosDesktop from "@/components/fichaCarreraU/IconosDesktop";
import IconosMobile from "@/components/fichaCarreraU/IconosMobile";
import DetallesCarreraTP from "@/components/fichaCarreraU/DetallesCarreraU";
import ApiUniversidades from "@/services/ApiUniversidades";
import MenuMovilTP from "@/components/generales/menuMovil/TecnicoProfesional";
import MenuMovilUni from "@/components/generales/menuMovil/AdmisionUniversitaria";
import { PdfDocument } from "@/utils/ConstructorPDF.js";
import MixinsIconos from "@/mixins/iconosInstituciones.js";

export default {
  name: "FichaCarreraU",
  components: {
    Titulo,
    IconosDesktop,
    IconosMobile,
    DetallesCarreraTP,
    MenuMovilTP,
    MenuMovilUni
  },
  mixins: [MixinsIconos],
  data() {
    return {
      carrera: {},
      origenRedirect: ""
    };
  },
  async created() {
    await this.getFicha();
  },
  computed: {
    datosContactame() {
      let datosContacto = {
        codigoIntitucion: this.carrera.codigo,
        codigoSede: this.carrera.sedes ? this.carrera.sedes[0].codigo : "",
        codigoCarrera: this.carrera.sedes
          ? this.carrera.sedes[0].carreras[0].codigo
          : ""
      };
      return datosContacto;
    },
    codigoDemre() {
      if (this.carrera.sedes) {
        return this.carrera.sedes[0].carreras[0].codigoDEMRE;
      }
    },
    nombreCarrera() {
      if (this.carrera.sedes) {
        return this.carrera.sedes[0].carreras[0].nombre;
      }
    },
    tituloEntregado() {
      if (this.carrera.sedes) {
        return this.carrera.sedes[0].carreras[0].titulo;
      }
    },
    sede() {
      if (this.carrera.sedes) {
        return this.carrera.sedes[0];
      }
    },
    detalleCarrera() {
      if (this.carrera.sedes) {
        return this.carrera.sedes[0].carreras[0];
      }
    },
    gradoAcademicoTexto() {
      if (this.carrera.sedes) {
        return this.carrera.sedes[0].carreras[0].gradoAcademico;
      }
    },
    tipoPostulacionTexto() {
      if (this.carrera.sedes) {
        return this.carrera.sedes[0].carreras[0].tipoPostulacion;
      }
    },
    textoM2() {
      const situacionM2 = this.carrera.sedes[0].carreras[0].ponderacion
        .situacionM2;
      let text;
      switch (situacionM2) {
        case "NO_SOLICITA":
          text = "No Solicita";
          break;
        case "SI_PONDERA":
          text = "Sí Pondera";
          break;
        case "SI_HABILITA":
          text = "Sí Habilita";
          break;
        default:
          "Sin Información";
          break;
      }
      return text;
    }
  },
  methods: {
    async getFicha() {
      this.$emit("cargar");
      let codigoInstitucion = this.$route.params.idInstitucion;
      let codigoCarrera = this.$route.params.codigoCarrera;
      this.origenRedirect = this.$route.params.origen;
      let data = await ApiUniversidades.getFichaCarrera(
        codigoInstitucion,
        codigoCarrera,
        true
      );
      if (data) {
        this.carrera = data;
      }
      this.$emit("cargado");
    },
    descargarFicha() {
      let nombreDocumento = this.carrera.nombre;

      let titulo = {
        institucion: this.carrera.nombreCorto,
        carrera: this.nombreCarrera,
        titulo: this.tituloEntregado,
        gradoAcademico: this.gradoAcademicoTexto,
        demre: this.codigoDemre
      };

      let iconos = {
        logoInstitucion: this.getBase64Image(this.carrera.logoBase64),
        acreditacion: this.textoAcreditacion(
          "UNIVERSIDAD",
          this.carrera.acreditado,
          this.carrera.acreditacion.anios,
          this.carrera.observacionAcreditacionCNA
        ),
        sede:
          this.sede.carreras[0].jornada === "A_DISTANCIA"
            ? "Aula Virtual"
            : this.sede.nombre,
        region:
          this.sede.carreras[0].jornada === "A_DISTANCIA"
            ? "-"
            : this.sede.regionNombreCorto,
        telefono: String(this.carrera.contacto.telefono),
        jornada: this.sede.carreras[0].jornada,
        postulacion: this.carrera.sedes[0].carreras[0].tipoPostulacion,
        duracion: `${
          this.sede.carreras[0].duracionFormalPrograma
        } ${this.sede.carreras[0].regimen.charAt(
          0
        )}${this.sede.carreras[0].regimen.slice(1).toLowerCase()}`,
        arancel: this.sede.carreras[0].arancelAnual,
        tipoMoneda: this.sede.carreras[0].tipoMoneda,
        vacantes: String(this.sede.carreras[0].vacantesRegulares),
        vacantesPACE: this.sede.carreras[0].vacantesPACE,
        vacantesBea: this.sede.carreras[0].vacantesBEA,
        observacionAcreditacionCNA: this.carrera.observacionAcreditacionCNA,
        acreditacionEspecialPandemiaCNA:
          this.carrera.acreditado && this.carrera.acreditacion.anios === 0
      };

      PdfDocument.init();
      PdfDocument.setTitulo("CARRERA_U", titulo);
      PdfDocument.setIconosCarreraU(iconos);
      PdfDocument.setDisclaimersAdicionales(
        iconos.observacionAcreditacionCNA,
        iconos.acreditacionEspecialPandemiaCNA,
        "UNIVERSIDAD"
      );
      PdfDocument.setRequisitosIngresoUniversidad(this.detalleCarrera);
      PdfDocument.setPerfilEgreso(this.detalleCarrera.perfilEgreso);
      PdfDocument.setEmpleabilidad(
        this.detalleCarrera.porcentajeEmpleabilidad,
        this.detalleCarrera.ingresoPromedioCuartoAnio
      );
      PdfDocument.openSinglePage(nombreDocumento);
      PdfDocument.reset();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/BuscadoresU/FichaCarreraU.vue